import handleRequest from '../../utils/handleRequest.js'
import getApiHost from '../../utils/getApiHost.js'

function updateContact (contact) {
  return handleRequest(
    getApiHost() + '/contacts/updateContact',
    {
      method: 'PATCH',
      headers: {
        authorization: window.localStorage.getItem('token') || '',
        'business-partner-id': window.localStorage.getItem('businessPartnerId') || ''
      },
      json: contact
    }
  ).json()
}

export default updateContact
